import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';

import {
  AvailableFeaturesForm,
  BestDayTime,
  BestDayTimePageForm,
  ConfigurationPageForm,
  MessageFrequencyCapping,
} from '../../constants';
import BestDayTimePage from './BestDayTimePage';
import journeyStatusEnums from '../../../../Enums/journeyStatus';

const styles = {
  configurationPageWrapper: {
    flexGrow: 1,
    padding: '0 16px 16px',
    marginTop: '10px',
  },
};

export const mapStateToProps = state => {
  const { metrics } = state.journeyBuilderUIDataArea.metrics;
  const { channels } = state.journeyBuilderUIDataArea.channels;
  const availableFeatureselector = formValueSelector(AvailableFeaturesForm);
  const activityType = availableFeatureselector(state, 'activityType');
  const selector = formValueSelector(BestDayTimePageForm);
  const bestDayTimeChannel = selector(state, 'bestDayTimeChannel');
  const configurationPageFormSelector = formValueSelector(ConfigurationPageForm);
  // eslint-disable-next-line iqvia/ternaries/no-null-ternary
  const configurationPageFormChannel = _.isNil(configurationPageFormSelector)
    ? null
    : configurationPageFormSelector(state, 'channel');
  const metric = selector(state, 'metric');
  const args = state.journeyBuilderConfigurationArea.activity.arguments;
  const journeyStatus = state.journeyBuilderConfigurationArea.interaction.status;
  const status =
    journeyStatus === journeyStatusEnums.DRAFT || journeyStatus === journeyStatusEnums.PAUSED
      ? false
      : true;
  const initialValues = {};
  initialValues.bestDayTimeChannel = bestDayTimeChannel;

  if (metric || metric === '') {
    initialValues.metric = metric;
  } else if (
    _.includes(activityType, BestDayTime) &&
    args.execute.inArguments.length > 0 &&
    args.execute.inArguments[0].metric
  ) {
    initialValues.metric = args.execute.inArguments[0].metric;
    if (args.execute.inArguments[0].bestDayTimeChannel) {
      initialValues.bestDayTimeChannel = args.execute.inArguments[0].bestDayTimeChannel;
    }
  }

  const data = {
    metrics,
    channels,
    bestDayTimeChannel,
    initialValues,
    configurationPageFormChannel,
    metric,
    activityType,
    status,
  };
  return data;
};

export const enhance = lifecycle({
  componentWillUpdate(nextProps) {
    if (nextProps.activityType !== this.props.activityType) {
      if (
        _.includes(this.props.activityType, BestDayTime) &&
        !_.includes(nextProps.activityType, BestDayTime)
      ) {
        this.props.change('metric', '');
        this.props.change('bestDayTimeChannel', '');
        this.props.change('initialValues.metric', '');
        this.props.change('initialValues.bestDayTimeChannel', '');
      }
    }
    if (
      _.includes(nextProps.activityType, MessageFrequencyCapping) &&
      _.includes(nextProps.activityType, BestDayTime)
    ) {
      if (nextProps.configurationPageFormChannel !== this.props.configurationPageFormChannel) {
        this.props.change('bestDayTimeChannel', '');
        this.props.change('initialValues.bestDayTimeChannel', '');
      }
    }
  },
})(BestDayTimePage);

export default compose(
  connect(mapStateToProps),
  reduxForm({
    form: BestDayTimePageForm,
    enableReinitialize: true,
    destroyOnUnmount: false,
  }),
  injectIntl,
  withStyles(styles, { name: 'BestDayTimePage' })
)(enhance);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/BestDayTime/index.js